import React from 'react'
import Lottie from 'react-lottie'
import './main.css'

export default function LottieAnimation({ lotti, width, height }) {
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: lotti,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
  }

  return (
    <div>
      <Lottie options={defaultOptions} height={height} width={width} zIndex={4} />
    </div>
  )
}
